<template>
    <modal @close="closeModal">
        <div class="u-margin-bottom">
            <a class="btn btn--sso" v-if="ssoUrl" :href="ssoUrl" target="_blank" rel="noopener" @click="closeModal">
                {{ trans('page.hosting.sso-link-text') }}
            </a>
            <span v-else>{{ trans('page.hosting.sso-link-wait') }}</span>
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { Modal } from 'relapp-modal';
import { apiMixin } from 'relapp-api';
import HostingApi from '../services/api/hosting.js';

export default {
    components: {
        Modal
    },
    mixins: [apiMixin],
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            ssoUrl: ''
        };
    },
    /**
     * Called after the instance has been created.
     */
    created() {
        HostingApi.createSSOLink(this.domain)
            .then(response => {
                this.ssoUrl = response.data.url;
            })
            .catch(error => this.handleError(error));
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>
